<template>
  <div class="cms-type-form">
    <drawer-dialog-controls
      :is-loading="isLoading"
      :is-pristine="isPristine"
      :is-disabled="!isFormValid"
      @close="$emit('close')"
      @save="$emit('save', localItem)"
    >
      {{ isNew ? 'New Type' : `Edit Type #${item.type_id}` }}
    </drawer-dialog-controls>

    <div class="form-content">
      <v-form v-model="isFormValid">
        <v-card>
          <v-card-title>Type Settings</v-card-title>
          <v-divider />
          <v-container>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="localItem.slug"
                  label="Slug"
                  :rules="[v => !!v || 'Slug is required']"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="localItem.name"
                  label="Name"
                  :rules="[v => !!v || 'Name is required']"
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="localItem.kind"
                  :items="kindOptions"
                  label="Kind"
                  dense
                  outlined
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="localItem.description"
                  label="Description"
                  rows="3"
                  auto-grow
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-form>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { DrawerDialogControls } from '@/components/core/DrawerDialog'
import { KIND_OPTIONS } from '@/components/cms/constants'

export default {
  components: {
    DrawerDialogControls,
  },
  props: {
    item: Object,
    isLoading: Boolean,
  },
  data() {
    return {
      localItem: {},
      isPristine: true,
      isFormValid: false,
      kindOptions: KIND_OPTIONS,
    }
  },
  computed: {
    isNew() {
      return !this.item.type_id
    },
  },
  created() {
    this.localItem = cloneDeep(this.item || {})
    const unwatch = this.$watch('localItem', () => {
      this.isPristine = false
      unwatch()
    }, { deep: true })
  },
}
</script>

<style scoped>
.cms-type-form {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.form-content {
  background-color: #F2F2F2;
  padding: 1rem;
  flex: 1;
  overflow-y: auto;
}
</style>